var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("v-combobox", {
        ref: "asset_id_input",
        staticClass: "chiped-input",
        class: _vm.dense ? "grv-input-dense" : "grv-input",
        attrs: {
          "menu-props": { contentClass: "grv-menu" },
          rules: _vm.rules,
          dense: "",
          value: _vm.value,
          clearable: "",
          chips: "",
          loading: _vm.loading,
          "small-chips": _vm.dense,
          name: _vm.param.name,
          "search-input": _vm.search,
          "deletable-chips": !_vm.readonly,
          items: _vm.items,
          multiple: _vm.multiple,
          readonly: _vm.readonly,
          "append-icon": "search"
        },
        on: {
          "update:error": function($event) {
            _vm.errored = $event
          },
          "update:searchInput": function($event) {
            _vm.search = $event
          },
          "update:search-input": function($event) {
            _vm.search = $event
          },
          "click:append": function($event) {
            return _vm.showTitleAssetFinder(_vm.param)
          },
          change: function($event) {
            return _vm.$emit("update:value", $event)
          }
        },
        scopedSlots: _vm._u([
          {
            key: "label",
            fn: function() {
              return [_c("Label", { attrs: { param: _vm.param } })]
            },
            proxy: true
          },
          {
            key: "selection",
            fn: function(ref) {
              var item = ref.item
              return [
                _c("AssetChip", {
                  attrs: { asset_id: item, asset: _vm.assets[item] },
                  on: {
                    remove: function($event) {
                      return _vm.remove(item)
                    }
                  }
                })
              ]
            }
          },
          {
            key: "item",
            fn: function(ref) {
              var tile = ref.tile
              var item = ref.item
              return [
                _c(
                  "v-list-tile-avatar",
                  [
                    tile.props.value
                      ? _c("v-icon", { attrs: { color: "primary" } }, [
                          _vm._v("check_box")
                        ])
                      : _c("v-icon", [_vm._v("check_box_outline_blank")])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-list-tile-content",
                  [
                    _c("v-list-tile-title", [
                      _vm._v("\n\t\t\t\t\t" + _vm._s(item) + "\n\t\t\t\t")
                    ]),
                    _vm._v(" "),
                    _c(
                      "v-list-tile-sub-title",
                      { staticClass: "font-italic caption" },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t" +
                            _vm._s(_vm.getAssetTitle(item)) +
                            "\n\t\t\t\t"
                        )
                      ]
                    )
                  ],
                  1
                )
              ]
            }
          },
          {
            key: "no-data",
            fn: function() {
              return [
                _c(
                  "v-list-tile",
                  [
                    _c(
                      "v-list-tile-content",
                      [
                        _c("v-list-tile-title", [
                          _vm._v(
                            "\n\t\t\t\t\t\tSaisissez un asset ID\n\t\t\t\t\t\t"
                          ),
                          _vm.search
                            ? _c("span", [
                                _vm._v('\n\t\t\t\t\t\t\t"'),
                                _c("strong", [_vm._v(_vm._s(_vm.search))]),
                                _vm._v('"\n\t\t\t\t\t\t')
                              ])
                            : _vm._e(),
                          _vm._v(".\n\t\t\t\t\t\tAppuyez sur "),
                          _c("kbd", [_vm._v("Entrée")]),
                          _vm._v(" pour l'ajouter\n\t\t\t\t\t")
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c("Hint", { attrs: { param: _vm.param, errored: _vm.errored } }),
      _vm._v(" "),
      _vm.titleAssetFinder.visible
        ? _c(
            "TitleAssetFinder",
            {
              attrs: {
                multiselect: _vm.multiple,
                toolbarTitle: _vm.titleAssetFinder.destination_key,
                return_objects: true,
                babel_id: _vm.babel_id,
                behive_category: _vm.behive_category
              },
              on: {
                close: function($event) {
                  _vm.titleAssetFinder.visible = false
                  _vm.titleAssetFinder.destination_key = null
                },
                selectedAssets: function($event) {
                  _vm.onAssetIdsSelected($event)
                  _vm.titleAssetFinder.destination_key = null
                }
              }
            },
            [
              _c("h3", { attrs: { slot: "header" }, slot: "header" }, [
                _vm._v("Asset Select")
              ])
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f6bb4376", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f6bb4376","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/scramble/app-loader.js!./src/components/fields/assetid.vue
// module id = null
// module chunks = 